import { initializeApp, getApp, getApps } from 'firebase/app';
import { getFirestore } from 'firebase/firestore';
import { getStorage } from 'firebase/storage';
import { getAuth, GoogleAuthProvider } from 'firebase/auth';
import { getDatabase } from 'firebase/database';

const getEnvVal = (key: string, defaultVal: string): string => {
  try {
    const env = (import.meta as any).env;
    return env[key] || defaultVal;
  } catch (e) {
    return defaultVal;
  }
};

const firebaseConfig = {
  apiKey: getEnvVal("VITE_FIREBASE_API_KEY", "AIzaSyDPZ4fenu8JQBG0sM5he245oY-Y1K72Kfc"),
  authDomain: getEnvVal("VITE_FIREBASE_AUTH_DOMAIN", "jswedu-9fc0e.firebaseapp.com"),
  databaseURL: getEnvVal("VITE_FIREBASE_DATABASE_URL", "https://jswedu-9fc0e-default-rtdb.firebaseio.com"),
  projectId: getEnvVal("VITE_FIREBASE_PROJECT_ID", "jswedu-9fc0e"),
  storageBucket: getEnvVal("VITE_FIREBASE_STORAGE_BUCKET", "jswedu-9fc0e.firebasestorage.app"),
  messagingSenderId: getEnvVal("VITE_FIREBASE_MESSAGING_SENDER_ID", "848220161212"),
  appId: getEnvVal("VITE_FIREBASE_APP_ID", "1:848220161212:web:ca10d2adf12e0b918bfcb9")
};

const app = !getApps().length ? initializeApp(firebaseConfig) : getApp();
export const db = getFirestore(app);
export const rtdb = getDatabase(app, firebaseConfig.databaseURL);
export const storage = getStorage(app);
export const auth = getAuth(app);
export const googleProvider = new GoogleAuthProvider();
